(function () {
   if (customElements.get('category-story-menu')) return;

   var debounce = function (fn, wait) {
      var t;
      return function () {
         clearTimeout(t);
         t = setTimeout(fn, wait);
      };
   };

   customElements.define('category-story-menu', class extends HTMLElement {
      connectedCallback() {
         this._viewport = this.querySelector('.csm-viewport');
         this._leftBtn = this.querySelector('.csm-arrow--left');
         this._rightBtn = this.querySelector('.csm-arrow--right');

         if (!this._viewport) return;

         var self = this;
         var step = function () {
            return Math.max(120, self._viewport.clientWidth - 80);
         };

         if (this._leftBtn) {
            this._leftBtn.addEventListener('click', function () {
               self._viewport.scrollBy({ left: -step(), behavior: 'smooth' });
            });
         }

         if (this._rightBtn) {
            this._rightBtn.addEventListener('click', function () {
               self._viewport.scrollBy({ left: step(), behavior: 'smooth' });
            });
         }

         var updateArrows = function () {
            var vp = self._viewport;
            var atStart = vp.scrollLeft <= 1;
            var atEnd = vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 1;
            self.classList.toggle('at-start', atStart);
            self.classList.toggle('at-end', atEnd);
         };

         this._viewport.addEventListener('scroll', debounce(updateArrows, 50), { passive: true });
         window.addEventListener('resize', debounce(updateArrows, 100));
         updateArrows();
      }
   });
})();
